"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Rect = _interopRequireDefault(require("./components/Rect"));

var _utils = require("./utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } _setPrototypeOf(subClass.prototype, superClass && superClass.prototype); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) { return o.__proto__; }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var centerToTL = function centerToTL(state) {
  var _state$position = state.position,
      centerX = _state$position.centerX,
      centerY = _state$position.centerY,
      _state$size = state.size,
      width = _state$size.width,
      height = _state$size.height,
      rotateAngle = state.transform.rotateAngle;
  var top = centerY - height / 2;
  var left = centerX - width / 2;
  return {
    top: top,
    left: left,
    width: width,
    height: height,
    rotateAngle: rotateAngle
  };
};

var tLToCenter = function tLToCenter(props) {
  var width = props.width,
      height = props.height,
      top = props.top,
      left = props.left,
      rotateAngle = props.rotateAngle;
  return {
    position: {
      centerX: left + width / 2,
      centerY: top + height / 2
    },
    size: {
      width: width,
      height: height
    },
    transform: {
      rotateAngle: rotateAngle
    }
  };
};

var ResizableRect = function (_Component) {
  function ResizableRect() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, ResizableRect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ResizableRect)).call.apply(_getPrototypeOf2, [this].concat(args))), _defineProperty(_defineProperty(_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRotate", function (angle, startAngle) {
      if (!_this.props.onRotate) return;
      var rotateAngle = Math.round(startAngle + angle);

      if (rotateAngle >= 360) {
        rotateAngle -= 360;
      } else if (rotateAngle < 0) {
        rotateAngle += 360;
      }

      if (rotateAngle > 356 || rotateAngle < 4) {
        rotateAngle = 0;
      } else if (rotateAngle > 86 && rotateAngle < 94) {
        rotateAngle = 90;
      } else if (rotateAngle > 176 && rotateAngle < 184) {
        rotateAngle = 180;
      } else if (rotateAngle > 266 && rotateAngle < 274) {
        rotateAngle = 270;
      }

      _this.props.onRotate(rotateAngle);
    }), "handleResize", function (length, alpha, rect, type, isShiftKey) {
      if (!_this.props.onResize) return;
      var _this$props = _this.props,
          rotateAngle = _this$props.rotateAngle,
          aspectRatio = _this$props.aspectRatio,
          minWidth = _this$props.minWidth,
          minHeight = _this$props.minHeight,
          parentRotateAngle = _this$props.parentRotateAngle;
      var beta = alpha - (0, _utils.degToRadian)(rotateAngle + parentRotateAngle);
      var deltaW = length * Math.cos(beta);
      var deltaH = length * Math.sin(beta);
      var ratio = isShiftKey && !aspectRatio ? rect.width / rect.height : aspectRatio;
      var style = (0, _utils.getNewStyle)(type, _objectSpread({}, rect, {
        rotateAngle: rotateAngle
      }), deltaW, deltaH, ratio, minWidth, minHeight);

      _this.props.onResize(centerToTL(_objectSpread({}, style, {
        transform: {
          rotateAngle: rotateAngle
        }
      })), isShiftKey, type);
    }), "handleDrag", function (deltaX, deltaY) {
      _this.props.onDrag && _this.props.onDrag(deltaX, deltaY);
    }), _temp));
  }

  _createClass(ResizableRect, [{
    key: "render",
    value: function render() {
      var styles = tLToCenter(this.props);
      var _this$props2 = this.props,
          zoomable = _this$props2.zoomable,
          rotatable = _this$props2.rotatable,
          parentRotateAngle = _this$props2.parentRotateAngle;
      return _react.default.createElement(_Rect.default, {
        zoomable: zoomable,
        rotatable: rotatable && this.props.onRotate ? true : false,
        styles: styles,
        parentRotateAngle: parentRotateAngle,
        onResizeStart: this.props.onResizeStart,
        onResize: this.handleResize,
        onResizeEnd: this.props.onResizeEnd,
        onRotateStart: this.props.onRotateStart,
        onRotate: this.handleRotate,
        onRotateEnd: this.props.onRotateEnd,
        onDragStart: this.props.onDragStart,
        onDrag: this.handleDrag,
        onDragEnd: this.props.onDragEnd
      });
    }
  }]);

  _inherits(ResizableRect, _Component);

  return ResizableRect;
}(_react.Component);

_defineProperty(_defineProperty(ResizableRect, "propTypes", {
  left: _propTypes.default.number.isRequired,
  top: _propTypes.default.number.isRequired,
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  rotatable: _propTypes.default.bool,
  rotateAngle: _propTypes.default.number,
  parentRotateAngle: _propTypes.default.number,
  zoomable: _propTypes.default.string,
  minWidth: _propTypes.default.number,
  minHeight: _propTypes.default.number,
  aspectRatio: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]),
  onRotateStart: _propTypes.default.func,
  onRotate: _propTypes.default.func,
  onRotateEnd: _propTypes.default.func,
  onResizeStart: _propTypes.default.func,
  onResize: _propTypes.default.func,
  onResizeEnd: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDrag: _propTypes.default.func,
  onDragEnd: _propTypes.default.func
}), "defaultProps", {
  parentRotateAngle: 0,
  rotateAngle: 0,
  rotatable: true,
  zoomable: '',
  minWidth: 10,
  minHeight: 10
});

var _default = ResizableRect;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-resizable-rotatable-draggable/lib/ResizableRect.js
// module id = 1070
// module chunks = 0